module.exports = function(vars) {
var __t, __p = '';
__p += '<li class="toolIconLive toolIconHidden"><span class="tooltipLeft ico watch-live-broadcast"\n  title="Watch Live Broadcast" data-title="Watch Live Broadcast"><i class="fa fa-play-circle-o"></i></span></li>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/liveToolBoxIcon.ejs